// extracted by mini-css-extract-plugin
export default {"button":"Os-z","reviewSort":"Ps-z"};